/**************************************************
 * Nombre:       LogoMenu
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import logo from "../../../Recursos/logo_oscuro.svg";
import logoRedondo from "../../../Recursos/logo_redondo.svg";
import {useAnimate} from "framer-motion"
import {useEffect} from "react";
import {useMediaQuery} from "@mui/system";
import {theme} from "../../../Tema";

const LogoMenu = ({open}) => {
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const [scope, animate] = useAnimate()

    useEffect(() => {
        if (scope.current && masSM) {
            animate(scope.current, {x: -200, transitionDuration: 0})
            setTimeout(() => {
                if (scope.current) {
                    animate(scope.current, {x: 1, transitionDuration: 0})
                }

            }, 500)
        }
    }, [open]);
    return (
        <Grid ref={scope} container justifyContent={open ? 'flex-start' : 'center'} size={12}
              sx={{marginBottom: open ? -4 : -4, marginTop: -1}}>
            <img src={open ? logo : logoRedondo} width={'auto'} height={'auto'} style={{maxHeight: 80}}
            />
        </Grid>
    )

}
export default LogoMenu